import React from 'react'
import { Form, ModalBody } from 'reactstrap';

export const DeleteDiscountCommon = (props) => {
    const {
        toggleModal, loading, saveDelete, name, code
    } = props;
    return (
        <Form className="theme-form" role="form" >
            <ModalBody>
                <p className="h6 txt-danger">Estas a punto de eliminar la campaña:</p>
                <b>{`${name}(${code})`}</b>
                <br />
                <p>¿Estás seguro de hacerlo?</p>
            </ModalBody>

        </Form>
    )
}



